<template>
    <div class="document-viewer">
        <div class="document-viewer-wrapper">
            <div class="frame-wrapper">
                <iframe :src="pdfSrc" height="100%" width="100%" ref="frame"
                        v-on:load="onLoadFrame"></iframe>
                <div class="global-message-box" v-if="!pdfSrc || docLoading">
                    <div class="spinner">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import randomColor from 'randomcolor'
    import $ from 'jquery'
    import {checkCrossPlatformEventCtrlKey, escapeRegExp} from "@/utils";
    import {Promise} from 'es6-promise-polyfill';

    const activeHighlightColor = '#ded6ff';
    const normalHighlightColor = '#fadeaf';

    function findNodeFrom(node, charIndex) {
        switch (node.nodeType) {
            case node.TEXT_NODE:
                if (node.textContent.length > charIndex) {
                    return [node, charIndex]
                }
                break;
            case node.COMMENT_NODE:
            case node.CDATA_SECTION_NODE:
                break;
            default:
                if (node.textContent.length > charIndex) {
                    let base = 0;
                    for (let i = 0; i < node.childNodes.length; i++) {
                        const childNode = node.childNodes[i];
                        const found = findNodeFrom(childNode, charIndex - base);
                        if (found) {
                            return found;
                        }
                        if (childNode instanceof HTMLElement) {
                            base += childNode.textContent.length;
                        } else {
                            base += childNode.textContent.length;
                        }
                    }
                }
        }
    }

    function appendHighlightSegmentIntoFrame(range, startNode, startNodeOffset, endNode, endNodeOffset, frameDocument, backgroundColor, oIndex, className, borderRadius, boxShadow, borderBottom) {
        range.setStart(startNode, startNodeOffset);
        range.setEnd(endNode, endNodeOffset);

        let clientRects;
        clientRects = range.getClientRects();

        let bodyScrollTop = frameDocument.documentElement.scrollTop;
        let bodyScrollLeft = frameDocument.documentElement.scrollLeft;

        for (let i = 0; i < clientRects.length; i++) {
            const rect = clientRects[i];
            const elem = frameDocument.createElement('div');
            elem.style.position = 'absolute';
            elem.style.top = (rect.top + bodyScrollTop) + 'px';
            elem.style.left = (rect.left + bodyScrollLeft) + 'px';
            elem.style.width = rect.width + 'px';
            elem.style.height = rect.height + 'px';
            elem.style.zIndex = '-1';
            elem.style.borderRadius = borderRadius || '3px';
            elem.dataset.oIndex = oIndex;
            elem.style.backgroundColor = backgroundColor;
            elem.className = className;
            elem.style.boxShadow = boxShadow || null;
            elem.style.borderBottom = borderBottom || null;

            frameDocument.body.appendChild(elem);
        }
    }

    export default {
        name: "DocumentViewerPdfjs",
        mounted() {
            // this.windowResizeListener = () => {
            //     this.repaintHighlights(false, this.ftCursor);
            // };
            this.windowKeydownListener = this.onWindowKeydown.bind(this);
            // window.addEventListener('resize', this.windowResizeListener);
            window.addEventListener('keydown', this.windowKeydownListener);
        },
        methods: {
            onTextareaInput(event) {
                const target = event.currentTarget;
                const v = target.value;
                if (v) {
                    setTimeout(() => {
                        if (target.value === v) {
                            this.highlightText(v, true);
                        }
                    }, 0);
                } else {
                    this.highlightText(null, true);
                }
            },
            onTextareaFocused(event) {
                const target = event.currentTarget;
                target.selectionStart = 0;
                target.selectionEnd = target.value.length;

                if (this.ftCursor >= 0) {
                    this.jumpToHighlightWithCursor(this.ftCursor);
                }
            },
            onLoadFrame(event) {
                const target = event.target;

                this.frameDocument = target.contentDocument;
                this.frameWindow = target.contentWindow;

                // this.frameDocument.body.style.padding = '11px 11px 11px 4px';

                // const frame = this.$refs.frame;
                // frame.contentWindow.addEventListener('keydown', this.windowKeydownListener);

                this.docLoading = false;
            },
            onWindowKeydown(event) {
                if (event.key === 'f' && event.shiftKey && checkCrossPlatformEventCtrlKey(event) && !this.isInvisible()) {
                    event.preventDefault();
                    this.showFindText(true)
                }
            },
            renderHighlightsForText(text, jumpToCurrentCursor, currentCursor) {
                let promiseForCount;

                const frameDocument = this.frameDocument;

                if (!frameDocument) {
                    promiseForCount = Promise.resolve({total: 0});
                    return {promiseForCount};
                }

                let promiseForHighlights = Promise.resolve();

                text = text.split(':::');

                const primaryText = text[0];
                const innerText = text[1];

                let escapedPrimaryText;
                let escapedInnerText;

                escapedPrimaryText = escapeRegExp(primaryText);

                let regForPrimary;

                if (/^\s+$/.test(escapedPrimaryText)) {
                    regForPrimary = new RegExp(escapedPrimaryText, 'g');
                } else {
                    regForPrimary = new RegExp(escapedPrimaryText.replace(/\s+/g, '\\s*'), 'gi');
                }

                let regForInner;

                if (innerText) {
                    escapedInnerText = escapeRegExp(innerText);
                    if (/^\s+$/.test(escapedInnerText)) {
                        regForInner = new RegExp(escapedInnerText, 'g');
                    } else {
                        regForInner = new RegExp(escapedInnerText.replace(/\s+/g, '\\s*'), 'gi');
                    }
                }

                const bodyText = frameDocument.body.textContent;

                let counter = 0;

                let startIndex, endIndex, start, end, startNode, startNodeOffset, endNode, endNodeOffset;
                let range = frameDocument.createRange();
                let matchedText;

                const _this = this;

                const highlightStory = this.highlightStory;

                let matches;

                try {
                    while ((matches = regForPrimary.exec(bodyText))) {
                        (function (matches, counter) {
                            promiseForHighlights = promiseForHighlights.then(() => {
                                return new Promise((resolve, reject) => {
                                    const doStaff = () => {
                                        if (_this.highlightStory !== highlightStory) {
                                            reject();
                                            return;
                                        }
                                        matchedText = matches[0];
                                        startIndex = matches.index;
                                        endIndex = startIndex + matchedText.length - 1;
                                        start = findNodeFrom(frameDocument.body, startIndex);
                                        end = findNodeFrom(frameDocument.body, endIndex);

                                        if (start && end) {
                                            startNode = start[0];
                                            startNodeOffset = start[1];
                                            endNode = end[0];
                                            endNodeOffset = end[1] + 1;

                                            let active = counter === currentCursor;

                                            appendHighlightSegmentIntoFrame(range, startNode, startNodeOffset, endNode, endNodeOffset, frameDocument,
                                                active ? activeHighlightColor : normalHighlightColor, String(counter), 'highlight highlight-general');

                                            if (jumpToCurrentCursor && counter === currentCursor) {
                                                _this.jumpToHighlightWithCursor(currentCursor);
                                            }

                                            if (regForInner) {
                                                let matchesInner;
                                                while ((matchesInner = regForInner.exec(matchedText))) {
                                                    let matchedTextInner = matchesInner[0];
                                                    let startIndexInner = matchesInner.index;
                                                    let endIndexInner = startIndexInner + matchedTextInner.length - 1;
                                                    let startInner = findNodeFrom(frameDocument.body, startIndexInner + startIndex);
                                                    let endInner = findNodeFrom(frameDocument.body, endIndexInner + startIndex);

                                                    if (startInner && endInner) {
                                                        appendHighlightSegmentIntoFrame(range, startInner[0], startInner[1], endInner[0], endInner[1] + 1, frameDocument,
                                                            'lightgreen', String(counter), 'highlight highlight-seed', '4px', '0 0 0 1px lightgreen');
                                                    }
                                                }
                                            }

                                        }
                                        resolve();
                                    };
                                    if (counter > 16) {
                                        setTimeout(doStaff, 0)
                                    } else {
                                        doStaff();
                                    }
                                })
                            })
                        })(matches, counter);
                        counter++;
                    }
                } catch (e) {
                    counter = 0;
                }

                promiseForCount = Promise.resolve({total: counter});

                return {promiseForHighlights, promiseForCount};
            },
            repaintHighlights(jumpToCurrentCursor, currentCursor) {
                this.highlightStory++;

                let promiseForCount;

                if (this.isInvisible()) {
                    promiseForCount = Promise.resolve({total: 0});
                    return {promiseForCount};
                }
                $(this.frameDocument.body).children('.highlight').remove();

                if (this.highlightingText) {
                    const r = this.renderHighlightsForText(this.highlightingText, jumpToCurrentCursor, currentCursor);
                    r.promiseForHighlights && r.promiseForHighlights.catch(() => {
                    });
                    return r;
                }

                promiseForCount = Promise.resolve({total: 0});
                return {promiseForCount};
            },
            jumpToHighlightWithCursor(cursor) {
                const $generalHighlightElems = $(this.frameDocument.body).children('.highlight.highlight-general');

                const $jumpToHighlightElems = $generalHighlightElems.filter(`[data-o-index="${cursor}"]`);

                $generalHighlightElems.not($jumpToHighlightElems).css('background-color', normalHighlightColor);

                const firstHighlightedElem = $jumpToHighlightElems[0];

                if (!firstHighlightedElem) {
                    return;
                }

                $jumpToHighlightElems.css('background-color', activeHighlightColor);

                this.frameDocument.documentElement.scrollTop = parseFloat(firstHighlightedElem.style.top) + parseFloat(firstHighlightedElem.style.height) / 2 - this.frameDocument.documentElement.clientHeight / 2;
                this.frameDocument.documentElement.scrollLeft = parseFloat(firstHighlightedElem.style.left) + parseFloat(firstHighlightedElem.style.width) / 2 - this.frameDocument.documentElement.clientWidth / 2;
            },
            highlightText(text, page) {
                const PDFViewerApplication = this.frameWindow.PDFViewerApplication;

                if (page && PDFViewerApplication.page !== page) {
                    PDFViewerApplication.page = page;
                } else {
                    PDFViewerApplication.page = 1;
                }

                PDFViewerApplication.findBar.findField.value = text;
                PDFViewerApplication.findBar.open();
            },
            showFindText(b) {
                const PDFViewerApplication = this.frameWindow.PDFViewerApplication;

                if (b) {
                    PDFViewerApplication.findBar.open();
                } else {
                    this.highlightText(null, true);
                }
            },
            jumpToNextHighlight() {
                if (this.canJumpNext) {
                    this.ftCursor++;
                    this.jumpToHighlightWithCursor(this.ftCursor);
                }
            },
            jumpToPrevHighlight() {
                if (this.canJumpPrev) {
                    this.ftCursor--;
                    this.jumpToHighlightWithCursor(this.ftCursor);
                }
            },
            isInvisible() {
                return this.$el.offsetParent === null;
            }
        },
        data: function () {
            return {
                frameDocument: null,
                frameWindow: null,
                highlightingText: null,
                windowResizeListener: null,
                ftTotal: 0,
                ftCursor: -1,
                windowKeydownListener: null,
                highlightStory: 0,
                docLoading: true
            }
        },
        props: {
            pdfSrc: String
        },
        destroyed() {
            // window.removeEventListener('resize', this.windowResizeListener);
            window.removeEventListener('keydown', this.windowKeydownListener);
        },
        computed: {
            canJumpNext() {
                return this.ftTotal > 0 && this.ftCursor < this.ftTotal - 1;
            },
            canJumpPrev() {
                return this.ftCursor > 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/variables";

    $findTextWrapperHeight: 2rem;

    .document-viewer {

        .document-viewer-wrapper {
            height: 100%;
            background-color: white;
            border-radius: 2px;
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2), 0 0 18px 0 rgba(black, 0.02);
        }

        iframe {
            border: none;
            margin: 0;
        }

        .frame-wrapper {
            height: 100%;
            position: relative;

            .global-message-box {
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(white, 0.8);
                font-size: 1rem;
            }
        }
    }

    .find-text-content {
        height: 100%;
        background-color: #f3f3f3;
        border-bottom: 1px solid #ddd;
        display: flex;
        align-items: center;
        padding: 0 0.6rem 0 0.8rem;

        .button-nav:first-of-type {
            margin: 0 0.25rem 0 0.8rem;
        }

        .button-close {
            background-color: transparent;
            border: none;
            outline: none;
            padding: 0;
            margin-left: 0.5rem;
            opacity: 0.8;
            font-size: 1rem;

            &:hover {
                opacity: 1;
            }
        }

        textarea {
            width: 100%;
            padding-right: 3rem;
            resize: none;
            overflow: hidden;
        }
    }
</style>
